import ICONS from "../../../../assets/Icons";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import { linkIdentifier } from "../../../../utils/linkIdentifier";
import IconTearDropButton from "../../CommonButtons/IconTearDropButton";
import PrimaryWithIconButton from "../../CommonButtons/PrimaryWithIconButton";

const AdditionalRecipients = ({
  setShowAdditionalSection,
  recipients = [],
  previewMode = false,
}) => {
  if (previewMode) {
    const safeRecipients = Array.isArray(recipients) ? recipients : [];

    return (
      <div className="flex flex-col bg-primary-card p-padding-md rounded-border-radius-md gap-gap-md">
        <div className="text-text-primary text-font-md">
          <span className="font-semibold">Recipients</span>
          <span className="font-normal"> (Optional)</span>
        </div>

        <div>
          <div className="text-text-primary text-font-md">
            {safeRecipients.length === GlobalConfiguration?.lengthCheckZero ? (
              <div className="mb-margin-xs">Not given</div>
            ) : (
              <div className="mb-margin-xs overflow-hidden overflow-ellipsis">
                {safeRecipients.map((item, index) => (
                  <span
                    key={index}
                    className="break-all"
                  >
                    {linkIdentifier(item.toLowerCase())}
                    {index <
                      safeRecipients.length -
                        GlobalConfiguration?.lengthCheckOne && ", "}
                  </span>
                ))}
              </div>
            )}
          </div>

          <div className="text-text-secondary text-font-xs font-normal">
            Recipients
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col relative w-width-full">
      <div className="p-padding-md h-height-full w-width-full bg-primary-card flex flex-col rounded-border-radius-md">
        <div className="w-width-full flex flex-col gap-gap-md">
          <div className="flex justify-between items-start">
            <div className="flex flex-col gap-gap-xs">
              <div className="text-text-primary text-font-md">
                <span className="font-semibold">Recipients</span>
                <span className="font-normal"> (Optional)</span>
              </div>
              <div className="text-text-secondary text-font-xs">
                The email IDs provided below will be used to send updates and
                notifications to the selected individuals.
              </div>
            </div>

            {recipients?.length > GlobalConfiguration?.lengthCheckZero && (
              <div className="top-top-base right-right-base absolute">
                <IconTearDropButton
                  handleFunction={() => setShowAdditionalSection(true)}
                  isDisabled={false}
                  isLoading={false}
                  enabledBgColor={"var(--primary-nav-act)"}
                  icon={ICONS?.EDIT}
                  hoverOption="white"
                />
              </div>
            )}
          </div>
          {recipients?.length > GlobalConfiguration?.lengthCheckZero ? (
            <div className="w-width-full">
              <div className="flex flex-wrap gap-gap-button-m mt-margin-sm w-width-full">
                {recipients.map((item, index) => (
                  <div
                    key={index}
                    className="bg-primary-nav text-text-primary overflow-hidden px-padding-button-l py-padding-button-m rounded-border-radius-md text-font-xs flex items-center gap-gap-xs"
                  >
                    <span className="break-all"> {linkIdentifier(item)}</span>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <PrimaryWithIconButton
              btnText="Add recipients"
              enabledBgColor="var(--primary-nav-act)"
              isDisabled={false}
              handleFunction={() => {
                setShowAdditionalSection(true);
              }}
              iconToBeAlign="left"
              enabledTextColor={"var(--text-primary)"}
              icon={ICONS?.ADDITIONAL_RECIPIENTS}
              fullWidthRequired={true}
              hoverOption="white"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default AdditionalRecipients;
